export default __webpack_public_path__ + "static/media/jira.a1508a15.svg";